// extracted by mini-css-extract-plugin
export default {"tooltipWrapper":"recharts-tooltip_tooltipWrapper__O7lE9","tooltipText":"recharts-tooltip_tooltipText__hNeH1"};